import React from "react";
import Modal from "react-modal";
import { FieldState } from "formstate";
import { observable } from "mobx";
import { AgentInput } from "@fidget/common/components/form/agentInput";
import { L10nHtml } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { validateRequired } from "@fidget/common/utils/validatorsFormState";
import { IRoom } from "../../models/room/Room";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";
import styles from "./currentClientContainer/currentClientContainer.css";
import { observer } from "mobx-react";

interface Props {
  room: IRoom;
}

interface State {
  isModalOpen: boolean;
}

interface DeleteField {
  input: FieldState<string>;
}

@observer
export class DeleteClient extends React.Component<Props, State> {
  @observable deleteField: DeleteField;
  constructor(props: Props) {
    super(props);
    this.state = {
      isModalOpen: false
    };
    this.deleteField = {
      input: new FieldState("")
        .disableAutoValidation()
        .validators(validateRequired, this.inputValidation)
    };
  }

  componentWillMount() {
    Modal.setAppElement("#app");
  }

  inputValidation = (val: string) => {
    return val === "delete" ? "" : intl.formatMessage("deleteClient.wrongInput");
  };

  closeModal = () => {
    this.setState({
      isModalOpen: false
    });
    this.deleteField = {
      input: new FieldState("")
        .disableAutoValidation()
        .validators(validateRequired, this.inputValidation)
    };
  };

  openModal = () => {
    this.setState({
      isModalOpen: true
    });
  };

  deleteClient = async () => {
    await this.deleteField.input.validate();
    if (!this.deleteField.input.hasError) {
      const { room } = this.props;
      room.owner.delete().then(() => {
        room.loadGuestProfile();
        room.reloadChat();
      });
      this.closeModal();
    }
  };

  renderModal = () => {
    return (
      <Modal
        isOpen={this.state.isModalOpen}
        shouldCloseOnEsc
        className={styles["modal-container"]}
        overlayClassName={styles.overlay}
        onRequestClose={this.closeModal}
        shouldCloseOnOverlayClick
      >
        <h2>{intl.formatMessage("deleteClient.header")}</h2>
        <p>{intl.formatMessage("deleteClient.info")}</p>
        <p>
          <L10nHtml id={"deleteClient.instruction"} />
        </p>
        <AgentInput
          id={styles.input}
          field={this.deleteField.input}
          styleType={"login"}
          maxLength={64}
          autoFocus
        />
        <div className={styles.buttons}>
          <AgentButton
            onClick={() => this.deleteClient()}
            buttonStyle={"outlined red"}
            fullWidth
            textStyle={{ fontSize: "16px", padding: "4px 0" }}
          >
            {intl.formatMessage("popup.button.confirm")}
          </AgentButton>
          <div></div>
          <AgentButton
            onClick={() => this.closeModal()}
            buttonStyle={"outlined primary"}
            fullWidth
            textStyle={{ fontSize: "16px", padding: "4px 0" }}
          >
            {intl.formatMessage("popup.button.cancel")}
          </AgentButton>
        </div>
        <button className={styles["close-button"]} onClick={this.closeModal}>
          <i className="icon-close-cross" />
        </button>
      </Modal>
    );
  };

  render() {
    const modal = this.renderModal();

    return (
      <>
        {this.state.isModalOpen && modal}
        <div className={styles["delete-client-button"]}>
          <AgentButton
            onClick={() => this.openModal()}
            buttonStyle={"outlined red"}
            fullWidth
            textStyle={{ fontSize: "16px", padding: "4px 0" }}
          >
            {intl.formatMessage("conversation.delete.client")}
          </AgentButton>
        </div>
      </>
    );
  }
}
